// extracted by mini-css-extract-plugin
export var clickableWrapper = "_24-2";
export var placeholderIcon = "_24-3";
export var thumbnailCanvas = "_24-1";
export var thumbnailWrapper = "_24-0";